export default __webpack_public_path__ + "static/media/image3.2261847f.png";